<template>
  <div class="container-fluid">
    <div class="panel panel-info">

      <!-- <div style="text-align: left; margin: 10px" class="p-3 mb-2">
        <h5>
           <b-button variant="danger" @click="handleBack">
                    <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill> Back
                </b-button>
          
        </h5>
        <hr />
      </div> -->
      <div class="p-3 mb-2">
    <h5>Medical Certificate:
     <b-btn
          class="btn-danger float-right"
           style="text-align: right;"
          @click="handleBack()"
        >
         <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill> Back
        </b-btn></h5>
      </div>
      <hr>
      <div class="panel-body">
        
          <div class="md-4">
            <b-card
             
              img-alt="Card image"
              img-left
              class="mb-3"
              style="height: 140px"
            >
            
              <b-card-text class="mycard">
                <table>
                  <tr>
                    <td width="45%" style="text-align: left">Tag No</td>
                    <td width="1%" style="text-align: left">:</td>
                    <td width="54%" style="text-align: left">22</td>
                  </tr>
                  <tr>
                    <td width="45%" style="text-align: left">Animal Type</td>
                    <td width="1%" style="text-align: left">:</td>
                    <td width="54%" style="text-align: left">Cow</td>
                  </tr>
                  <tr>
                    <td width="45%" style="text-align: left">Owner Name</td>
                    <td width="1%" style="text-align: left">:</td>
                    <td width="54%" style="text-align: left">Rajesh sharma</td>
                  </tr>
                  <tr>
                    <td width="45%" style="text-align: left">Village/City</td>
                    <td width="1%" style="text-align: left">:</td>
                    <td width="54%" style="text-align: left">solapur</td>
                  </tr>
                </table>
              </b-card-text>
              <b-card-text class="mycard"> </b-card-text>
            </b-card>

           
          </div>
          <div class="form-group">
            <label for="exampleFormControlTextarea1"
              ><b> Doctor Observations:</b></label
            >
            <textarea
              class="form-control"
              value="AS"
              id="exampleFormControlTextarea1"
              rows="3"
              disabled
              
            > This Animal is Medically Fit.</textarea>
          </div>
      <div class="col-sm-12">
                <button
          type="button"
          class="btn btn-xs btn-primary col-12"
         
        >
          Download
        </button> 

        </div>
      </div>
      </div>
      </div>
  
</template>

<script>
import * as _ from "lodash";

//import ApplicationFilter from "../components/ApplicationFilter.vue";
//import MarksEntry from "../components/MarksEntry.vue";
//alert(1);
export default {
  methods: {
    reset_details() {
      this.Observations = "";
    },
    
     handleBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style>
table {
  font-family: arial, sans-serif;

  width: 100%;
}

td,
th {
  border: 0px solid #dddddd;
  text-align: left;
  padding: 2px;
}
.mycard {
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>
